(function () {
  'use strict';
  var COLORS = ['Noir', 'Blanc', 'Gris'];

  function findAddToCartForm(sectionId) {
    var pfc = document.querySelector('product-form-component[data-section-id="' + sectionId + '"]');
    return pfc ? pfc.querySelector('form') : null;
  }

  function ensureHiddenInput(sectionId) {
    var form = findAddToCartForm(sectionId);
    if (!form) return null;
    var input = form.querySelector('input[name="properties[Composition]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Composition]';
      form.appendChild(input);
    }
    return input;
  }

  function distribute(n) {
    var base = Math.floor(n / 3);
    var rem = n % 3;
    return {
      Noir: base + (rem >= 1 ? 1 : 0),
      Blanc: base + (rem >= 2 ? 1 : 0),
      Gris: base
    };
  }

  function initComposition(root) {
    if (root._skInit) return;
    root._skInit = true;

    // The Pack radio-list fieldset is always the element immediately
    // preceding this composition panel in the markup (see
    // variant-main-picker.liquid) — walking to it directly avoids relying
    // on the internal DOM structure of Shopify's <variant-picker> element.
    var fieldset = root.previousElementSibling;
    var sectionId = root.getAttribute('data-section-id');
    var totalEl = root.querySelector('[data-sk-total]');
    var targetEl = root.querySelector('[data-sk-target]');
    var statusEl = root.querySelector('[data-sk-status]');
    var rows = [].slice.call(root.querySelectorAll('[data-sk-color]'));

    // Server-rendered markup already contains a valid, fully-allocated
    // distribution for the default pack size — read it instead of
    // assuming zero, so the widget stays correct even before this script
    // finishes loading/running.
    var target = parseInt(targetEl && targetEl.textContent, 10) || 0;
    var counts = { Noir: 0, Blanc: 0, Gris: 0 };
    rows.forEach(function (row) {
      var color = row.getAttribute('data-sk-color');
      var valueEl = row.querySelector('[data-sk-value]');
      counts[color] = parseInt(valueEl && valueEl.textContent, 10) || 0;
    });

    function render() {
      var sum = counts.Noir + counts.Blanc + counts.Gris;
      if (totalEl) totalEl.textContent = sum;
      if (targetEl) targetEl.textContent = target;

      rows.forEach(function (row) {
        var color = row.getAttribute('data-sk-color');
        var valueEl = row.querySelector('[data-sk-value]');
        if (valueEl) valueEl.textContent = counts[color];
        var minusBtn = row.querySelector('[data-sk-minus]');
        var plusBtn = row.querySelector('[data-sk-plus]');
        if (minusBtn) minusBtn.disabled = counts[color] <= 0;
        if (plusBtn) plusBtn.disabled = sum >= target;
      });

      var ok = target > 0 && sum === target;
      root.classList.toggle('sk-composition--ok', ok);
      root.classList.toggle('sk-composition--invalid', !ok);

      if (statusEl) {
        if (target === 0) {
          statusEl.textContent = '';
        } else if (sum < target) {
          statusEl.textContent = (target - sum) + ' paire(s) à répartir';
        } else if (sum > target) {
          statusEl.textContent = 'Trop de paires sélectionnées';
        } else {
          statusEl.textContent = 'Répartition complète';
        }
      }

      var hidden = ensureHiddenInput(sectionId);
      if (hidden) {
        if (ok) {
          var parts = [];
          COLORS.forEach(function (c) {
            if (counts[c] > 0) parts.push(counts[c] + ' ' + c);
          });
          hidden.value = parts.join(', ');
        } else {
          hidden.value = '';
        }
      }
    }

    function setTarget(n) {
      target = n > 0 ? n : 0;
      counts = distribute(target);
      render();
    }

    rows.forEach(function (row) {
      var color = row.getAttribute('data-sk-color');
      var minusBtn = row.querySelector('[data-sk-minus]');
      var plusBtn = row.querySelector('[data-sk-plus]');
      if (minusBtn) {
        minusBtn.addEventListener('click', function () {
          if (counts[color] > 0) {
            counts[color]--;
            render();
          }
        });
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', function () {
          var sum = counts.Noir + counts.Blanc + counts.Gris;
          if (sum < target) {
            counts[color]++;
            render();
          }
        });
      }
    });

    function bindForm() {
      var form = findAddToCartForm(sectionId);
      if (!form || form._skBound) return;
      form._skBound = true;
      form.addEventListener('submit', function (e) {
        if (!root.classList.contains('sk-composition--ok')) {
          e.preventDefault();
          e.stopPropagation();
          root.classList.add('sk-composition--shake');
          if (statusEl) {
            statusEl.textContent = 'Merci de répartir les ' + target + ' paires avant d’ajouter au panier.';
          }
          setTimeout(function () {
            root.classList.remove('sk-composition--shake');
          }, 420);
        }
      }, true);
    }
    bindForm();
    setTimeout(bindForm, 500);

    if (fieldset) {
      fieldset.addEventListener('change', function (e) {
        var input = e.target;
        if (input && input.type === 'radio') {
          setTarget(parseInt(input.value, 10) || 0);
        }
      });
    }

    // Sync the add-to-cart form's hidden property immediately, since the
    // panel may already be complete from the server-rendered defaults.
    render();
  }

  function init() {
    [].slice.call(document.querySelectorAll('[data-sk-composition]')).forEach(initComposition);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
